import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1621fb88"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { key: 0 }

import { FrontendProfile } from '@/shared/models/Profile'
import { ProfileDTO } from '@/business-logic/wallet'

const bytesWidth = 50


export default /*#__PURE__*/_defineComponent({
  __name: 'UserName',
  props: {
    profile: {},
    maxWidth: { default: 200 },
    extraClass: { default: '' },
    nameClass: { default: '' },
    hasAtSign: { type: Boolean, default: true },
    addressClass: { default: '' },
    isSmall: { type: Boolean, default: false },
    testId: { default: 'username-address' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["profile-name is-flex", `${_ctx.extraClass} ${_ctx.isSmall ? 'is-small' : ''}`]),
    "data-testid": _ctx.testId
  }, [
    (_ctx.profile.name)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          style: _normalizeStyle({
        maxWidth: `${_ctx.maxWidth - bytesWidth}px`,
      }),
          class: _normalizeClass(["truncate", _ctx.nameClass])
        }, [
          (_ctx.hasAtSign)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "@"))
            : _createCommentVNode("v-if", true),
          _createTextVNode(_toDisplayString(_ctx.profile.name), 1 /* TEXT */)
        ], 6 /* CLASS, STYLE */))
      : _createCommentVNode("v-if", true),
    (_ctx.profile.name)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["grey", _ctx.nameClass])
        }, _toDisplayString(_ctx.profile.address ? `#${_ctx.profile.address.slice(2, 6)}` : ''), 3 /* TEXT, CLASS */))
      : (_openBlock(), _createElementBlock("span", {
          key: 2,
          style: _normalizeStyle({ maxWidth: `${_ctx.maxWidth}px` }),
          class: _normalizeClass(["truncate", _ctx.nameClass])
        }, _toDisplayString(_ctx.profile.address), 7 /* TEXT, CLASS, STYLE */))
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})